import Vue from 'vue';
import PhotoGallery from './PhotoGallery';

Vue.component('ui-photo-gallery', PhotoGallery);
